import { URL } from './urls';

export default function checkIsTokenAlive(accesToken) {
  const apiURL = URL + `/check_is_token_alive`

  return fetch(apiURL, {
    headers: {
      'Authorization': `Bearer ${accesToken}`
    }
  })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch(() => 'Token exìred');

}